import { LASTEST_TAB } from "modules/ResearchReport/const";

type PathRoutes = {
  auth: {
    login: string;
  };
  view: {
    button: string;
    table: string;
    date: string;
  };
  homepage: string;
  personnelInformation: string;
  contractProcess: string;
  workPerformance: string;
  declareLeave: {
    parameter: string;
    base: string;
    tabs: {
      timeKeeping: string;
    };
    list: {
      parameter: string;
    };
    detail: {
      parameter: string;
    };
  };
  personnelForm: string;
  operationProcess: string;
  regulations: string;
  internalCulture: string;
  news: {
    parameter: string;
    base: string;
    tabs: {
      daily: string;
    };
    detail: {
      parameter: string;
    };
  };
  event: {
    parameter: string;
    base: string;
    tabs: {
      inProgress: string;
      inComing: string;
      over: string;
    };
    eventDetail: {
      parameter: string;
    };
    programDetail: {
      parameter: string;
    };
  };
  birthday: {
    parameter: string;
    base: string;
  };
  researchReport: {
    parameter: string;
    base: string;
    tabs: {
      lastest: string;
    };
    detail: {
      parameter: string;
    };
  };
  internalDocument: {
    parameter: string;
    base: string;
    tabs: {
      general: string;
    };
    detail: {
      parameter: string;
      tabContent: string;
    };
  };

  authorizationDocument: {
    parameter: string;
    base: string;
    tabs: {
      general: string;
    };
    status: {
      active: string;
      inactive: string;
    };
    detail: {
      parameter: string;
      tabContent: string;
    };
  };

  recruitment: {
    parameter: string;
    base: string;
    detail: {
      parameter: string;
    };
  };
  evaluation: {
    parameter: string;
    base: string;
    tabs: {
      filter: string;
      schedule?: string;
      evaluate?: string;
    };
    detail: {
      parameter: string;
    };
    list: {
      parameter: string;
    };
  };
  salary: {
    base: string;
    parameter: string;
    tabs: {
      regular: string;
      total?: string;
    };
  };
  extra: {
    mbsBirthday26: string;
  };
};

const pathRoutes: PathRoutes = {
  auth: {
    login: "/login",
  },
  view: {
    button: "view/button",
    table: "view/table",
    date: "view/date",
  },
  homepage: "/homepage",
  personnelInformation: "/personnel-information",
  workPerformance: "/work-Performance",
  declareLeave: {
    parameter: "/declare-leave/:tab",
    base: "/declare-leave",
    tabs: {
      timeKeeping: "/time-keeping",
    },
    list: {
      parameter: "/declare-leave/:tab/:type",
    },
    detail: {
      parameter: "/declare-leave/:tab/:type/:id",
    },
  },
  personnelForm: "/personnel-form",
  operationProcess: "/operation-process",
  regulations: "/regulations",
  contractProcess: "/contract-process",
  internalCulture: "/internal-culture",
  news: {
    parameter: "/news/:tab",
    base: "/news",
    tabs: {
      daily: "/daily",
    },
    detail: {
      parameter: "/news/:tab/:id",
    },
  },
  event: {
    parameter: "/events/:tab",
    base: "/events",
    tabs: {
      inProgress: "/in-progress",
      inComing: "/in-coming",
      over: "/over",
    },
    eventDetail: {
      parameter: "/events/:tab/:eventId",
    },
    programDetail: {
      parameter: "/events/:tab/:eventId/:programId",
    },
  },
  researchReport: {
    parameter: "/research-report/:tab",
    base: "/research-report",
    tabs: {
      lastest: `/${LASTEST_TAB}`,
    },
    detail: {
      parameter: "/research-report/:tab/:id",
    },
  },
  birthday: {
    parameter: "/employee-birthday",
    base: "/employee-birthday",
  },
  internalDocument: {
    parameter: "/internal-document/:tab",
    base: "/internal-document",
    tabs: {
      general: `/general`,
    },
    detail: {
      parameter: "/internal-document/:tab/:id/:content",
      tabContent: "/internal-document/:tab/:id/content",
    },
  },
  authorizationDocument: {
    parameter: "/authorization-document/:tab/:status",
    base: "/authorization-document",
    tabs: {
      general: `/general`,
    },
    status: {
      active: `/active`,
      inactive: `/inactive`,
    },
    detail: {
      parameter: "/authorization-document/:tab/:status/:id/:content",
      tabContent: "/authorization-document/:tab/:status/:id/content",
    },
  },

  recruitment: {
    parameter: "/recruitment",
    base: "/recruitment",
    detail: {
      parameter: "/recruitment/:id",
    },
  },
  evaluation: {
    parameter: "/evaluation/:tab",
    base: "/evaluation",
    tabs: {
      filter: `/filter`,
      schedule: `/schedule`,
      evaluate: `/evaluate`,
    },
    detail: {
      parameter: "/evaluation/:tab/:id/:reviewCvId",
    },
    list: {
      parameter: "/evaluation/:tab/:id",
    },
  },
  salary: {
    base: "/salary",
    parameter: "/salary",
    tabs: {
      regular: `/regular`,
      total: `/total`,
    },
  },
  extra: {
    mbsBirthday26: "/MBS-birthday-26",
  },
};

export default pathRoutes;
